// lib
export const isLogin = (key) => {
  const userInfo = window.sessionStorage.getItem(key);
  return !!userInfo;
};

export const getUserInfo = (key) => {
  return JSON.parse(window.sessionStorage.getItem(key));
};

export const getToken = (key) => {
  const userInfo = JSON.parse(window.sessionStorage.getItem(key));
  return userInfo && userInfo.token;
};
// 隔离环境
export const getScmProject = (key) => {
  const userInfo = JSON.parse(window.sessionStorage.getItem(key));
  return userInfo && userInfo.tb_eagleeyex_scm_project;
};



// WEBPACK FOOTER //
// ./src/utils/auth.js